// eslint-disable-next-line import/prefer-default-export
export enum ContentType {
  NOT_SELECTED = "NOT_SELECTED",
  SELECTED = "SELECTED",
  SUCCESS = "SUCCESS",
}
